import { css, Theme } from '@emotion/react'
import { selectClasses } from '@mui/material'

export const edit = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

export const editIcon = css`
  cursor: pointer;
`

export const longText = css`
  max-height: 60px;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    display: none;
  }
`

export const modalContainer = (theme: Theme) => css`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: ${theme.backgrounds.backgroundFour};
  border: 1px solid ${theme.backgrounds.backgroundOne};
  box-shadow: ${theme.boxShadows.small};
  border-radius: 24px;
  padding: 22px;
  width: 461px;
  box-sizing: border-box;
  max-height: 90vh;
  overflow: scroll;

  &::-webkit-scrollbar {
    display: none;
  }
`

export const modalForm = css`
  display: flex;
  flex-direction: column;
  gap: 22px;
`

export const modalTitle = css`
  font-weight: 700;
  text-align: center;
`

export const label = (theme: Theme) => css`
  color: ${theme.typographyColors.typographyThree};
  text-align: start;
`

export const select = css`
  .${selectClasses.select} {
    padding-right: 20px !important;
    text-align: start;
  }
`

export const descriptionInput = css`
  box-sizing: border-box;
  width: 415px;
  min-width: 415px;
  max-width: 415px;
  min-height: 120px;
`

export const buttons = css`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 10px;
`

export const button = css`
  width: 200px;
`

export const fullButton = css`
  width: 417px;
`
